<template lang="">
  <div>
    <!--div class="row mt-6">
      <div class="col col-sm-12 col-md-12">
        <p class="text-h6 text-uppercase text-center font-weight-medium">
          Datos de la negociación
        </p>
        <hr />
      </div>
    </div-->

    <div class="row">
      <div class="col col-md-4 col-xs-4">
        <img
          class="m-10"
          src="../../../assets/img/marnLogo.png"
          alt="Girl in a jacket"
          width="250"
          height="70"
        />
      </div>
      <div class="col col-md-4 col-xs-4"></div>
      <div class="col col-md-4 col-xs-4 float-lg-right">
        <img
          v-if="tipoPago === 'TARJETA'"
          class="m-10"
          src="../../../assets/img/rubrica.png"
          alt="Girl in a jacket"
          width="70"
          height="70"
        />
      </div>
    </div>
    <v-row cols="12" class="mt-0">
      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="ml-15" v-if="tipoPago === 'TARJETA'">
          <h5><strong>63-A2 ELECTRONICO</strong></h5>
        </div>
      </v-col>

      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="text-center">
          <h5><strong>MINISTERIO DE AMBIENTE Y</strong></h5>
        </div>
      </v-col>

      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="text-center" v-if="tipoPago === 'TARJETA'">
          <h6><strong>CORRELATIVO CGC NO. 1</strong></h6>
        </div>
      </v-col>
    </v-row>
    <v-row cols="12" class="mt-0">
      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="ml-15" v-if="tipoPago === 'TARJETA'">
          <h6><strong>RECIBO DE INGRESOS VARIOS </strong></h6>
        </div>
      </v-col>

      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="text-center">
          <h5><strong>RECURSOS NATURALES</strong></h5>
        </div>
      </v-col>

      <v-col xl="4" lg="4" md="4" xs="4">
        <div class="text-center" v-if="tipoPago === 'TARJETA'">
          <h5>SERIE “A”</h5>
        </div>
      </v-col>
    </v-row>
    <v-row cols="12" class="mt-10">
      <v-col xl="12" lg="12" md="12" xs="12">
        <div class="text-center">
          <h5>
            <strong>DIRECCION DE GESTION AMBIENTAL Y RECURSOS NATURALES</strong>
          </h5>
        </div>
      </v-col>
    </v-row>
    <v-row cols="12" class="mt-0">
      <v-col xl="6" lg="6" md="6" xs="6">
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Número Cobro:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>{{ datosPdf.cobro }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Nit:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>{{ datosPdf.nitProponente }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Nombre:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>{{ datosPdf.nombreProponente }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Dirección:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>{{ datosPdf.direccionProponente }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Teléfono:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>{{ datosPdf.telefonoProponente }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Observaciones:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>Ninguna</h6>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col xl="6" lg="6" md="6" xs="6">
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Fecha Emisión:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>{{ datosPdf.fechaEmision }}</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-0">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Período Licencia:</h6>
            </div>
          </v-col>
        </v-row>
        <v-row cols="12" class="mt-">
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="ml-15 text-start">
              <h6>Expediente:</h6>
            </div>
          </v-col>
          <v-col xl="6" lg="6" md="6" xs="6">
            <div class="text-start">
              <h6>{{ datosPdf.no_Expediente }}</h6>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row cols="12" class="mt-">
      <v-col xl="12" lg="12" md="12" xs="12">
        <v-card class="m-10">
          <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
          ></v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row cols="12" class="m-10">
      <v-col xl="12" lg="12" md="12" xs="12">
        <p v-if="tipoPago === 'TARJETA'">
          AUTORIZADO RESOLUCION. C.G.C. AO./000893 GESTION 471793 DE FECHA
          19-5-2020, E. FISCAL 4-A1-CCC 16546 DE FECHA 20-5- 2020, AUTORIZADO
          DEL 1 AL 100,000 LIBRO AB3 FOLIO 137. MARN, NIT: 2556261-4 ,
          CUENTADANCIA M2-8, 63-A2 RECIBO DE INGRESOS VARIOS ELECTRONICO, CON
          SERIE.
        </p>
        <p>
          ORIGINAL: CLIENTE
        </p>
        <p>
          DUPLICADO: MARN
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    datosPdf: {},
    tipoPago: {},
  },
  data() {
    return {
      cobro: 0,
      monto: 0,
      descripcion: "",
      fechaEmision: "",
      no_Expediente: "",
      categoria: "",
      nitProponente: "",
      nombreProponente: "",
      direccionProponente: "",
      telefonoProponente: "",
      headers: [
        {
          text: "Código Cobro",
          align: "start",
          sortable: false,
          value: "codigo",
        },
        { text: "Categoria", value: "categoria" },
        { text: "Cantidad", value: "catidad" },
        { text: "Precio", value: "precio" },
        { text: "Total", value: "total" },
      ],
      desserts: [],
    };
  },
  mounted() {

    if (this.datosPdf) {
      this.desserts.push({
        codigo: this.datosPdf.cobro,
        categoria: this.datosPdf.categoria,
        catidad: 1,
        precio: this.datosPdf.monto,
        total: this.datosPdf.monto,
      });
      // this.cobro = this.datosPdf.cobro;
      // this.monto = this.datosPdf.monto;
      // this.descripcion = this.datosPdf.descripcion;
      // this.fechaEmision = this.datosPdf.fechaEmision;
      // this.no_Expediente = this.datosPdf.no_Expediente;
      // this.categoria = this.datosPdf.categoria;
      // this.nitProponente = this.datosPdf.nitProponente;
      // this.nombreProponente = this.datosPdf.nombreProponente;
      // this.direccionProponente = this.datosPdf.direccionProponente;
      // this.telefonoProponente = this.datosPdf.telefonoProponente;

    }
  },
  
};
</script>
<style lang=""></style>
